import { AnyApiFactory } from '@backstage/core-plugin-api';

/**
 * API overrides and additional API factories.
 *
 * Plugins register their own APIs via createApiFactory in their plugin.ts.
 * This file is for app-level overrides or additional factories.
 */
export const apis: AnyApiFactory[] = [];
